import { render, staticRenderFns } from "./PageTurnControl.vue?vue&type=template&id=2dd0ab62&scoped=true&"
import script from "./PageTurnControl.vue?vue&type=script&lang=js&"
export * from "./PageTurnControl.vue?vue&type=script&lang=js&"
import style0 from "./PageTurnControl.vue?vue&type=style&index=0&id=2dd0ab62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd0ab62",
  null
  
)

export default component.exports